export default __webpack_public_path__ + "static/media/PPI-driveway-006.927c57fb.jpg";